module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-3.a790bbdb.svg";